/**
 * Thrown by `Sdk.resource(...)` when the requested resource is not in the
 * viewer's policy-filtered catalog, and by `Sdk.resourceId(...)` when the
 * requested slug is not in the workspace's registry. Both are authoring
 * conditions (the page references a resource the audience cannot reach), not
 * platform faults, so they are kept out of remote telemetry.
 */
export class UnknownResourceError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'UnknownResourceError';
  }
}
